import { FC, Fragment } from 'react';
import { Typography } from '@mui/material';
import cn from 'classnames';

import { getItineraryTimingV2, useBreakpoints } from '@mopla/utils';

import { RidePointIcon } from '../RidePointIcon';

import { GridLayout, StationName } from './TripScheme.styles';

interface IOneLegSchemeProps {
	className?: string;
	testId: string;
	preparedItineraryTimingSegments: Array<
		NonNullable<ReturnType<typeof getItineraryTimingV2>>
	>;
}

export const TripSchemeLayout: FC<IOneLegSchemeProps> = ({
	className,
	testId,
	preparedItineraryTimingSegments,
}) => {
	const { isMobile } = useBreakpoints();

	return (
		<GridLayout className={className} data-testid={testId}>
			{preparedItineraryTimingSegments.map((timingSegment, index) => {
				return (
					<Fragment key={index}>
						<div className="startTime">
							<Typography
								variant={isMobile ? 'body2' : 'body1'}
								fontWeight={600}
								color={
									timingSegment.isStartTimeChanged ? 'neutral.60' : 'black'
								}
								sx={{
									textDecoration: timingSegment.isStartTimeChanged
										? 'line-through'
										: 'none',
								}}
							>
								{timingSegment.startTime}
							</Typography>
							{timingSegment.effectiveStartTime &&
								timingSegment.isStartTimeChanged && (
									<Typography
										variant={isMobile ? 'body2' : 'body1'}
										fontWeight={600}
										color="warning.main"
									>
										{timingSegment.effectiveStartTime}
									</Typography>
								)}
						</div>

						<div className="withPath startIcon">
							<RidePointIcon
								pointType={timingSegment.startLeg.from.locationType}
							/>
							<div className="pathWrapper">
								<div className="path" />
							</div>
						</div>

						<div className="address">
							<StationName
								variant={isMobile ? 'body2' : 'body1'}
								fontWeight={600}
								title={timingSegment.startLeg.from.name}
								noWrap
							>
								{timingSegment.startLeg.from.name}
							</StationName>
						</div>

						<div className="endTime">
							<Typography
								variant={isMobile ? 'body2' : 'body1'}
								fontWeight={600}
								color={timingSegment.isEndTimeChanged ? 'neutral.60' : 'black'}
								sx={{
									textDecoration: timingSegment.isEndTimeChanged
										? 'line-through'
										: 'none',
								}}
							>
								{timingSegment.endTime}
							</Typography>
							{timingSegment.effectiveEndTime &&
								timingSegment.isEndTimeChanged && (
									<Typography
										variant={isMobile ? 'body2' : 'body1'}
										fontWeight={600}
										color="warning.main"
									>
										{timingSegment.effectiveEndTime}
									</Typography>
								)}
						</div>

						<div
							className={cn({
								endIcon: true,
								withPath: preparedItineraryTimingSegments.length - 1 > index,
							})}
						>
							<RidePointIcon pointType={timingSegment.endLeg.to.locationType} />
							{preparedItineraryTimingSegments.length - 1 > index && (
								<div className="pathWrapper">
									<div className="path" />
								</div>
							)}
						</div>

						<div className="address">
							<StationName
								variant={isMobile ? 'body2' : 'body1'}
								fontWeight={600}
								title={timingSegment.endLeg.to.name}
								noWrap
							>
								{timingSegment.endLeg.to.name}
							</StationName>
						</div>
					</Fragment>
				);
			})}
		</GridLayout>
	);
};
